export default __webpack_public_path__ + "static/media/480_business03-jp-web.f8cd0a0f.png";